export default "__VITE_ASSET__Clf3e2Sn__"